/**
 * The strings both informational pages render.
 *
 * **Copy addresses the operator, never the reviewer.** Design rationale, a
 * hostname read as technical vocabulary, and a restatement of a mechanic the
 * operator can already see are all barred from the interface and live in the
 * companion spec instead. The test before a sentence ships: can the operator act
 * differently after reading it?
 */
export const sharedCopy = {
  crumbs: {
    console: 'لوحة التشغيل',
  },

  /** The two-entry strip — the only thing that makes `/pages/contact` reachable. */
  strip: {
    label: 'الصفحات التعريفية',
    about: 'من نحن',
    contact: 'اتصل بنا',
  },

  identity: {
    heading: 'هويّة الصفحة',
    page: 'الصفحة',
    path: 'المسار العامّ',
    body: 'الجسم',
  },

  lede: {
    heading: 'السطر القائد',
    label: 'السطر القائد',
  },

  actions: {
    save: 'احفظ الصفحة',
    reset: 'أعد الحقول',
  },

  saved: {
    title: 'حُفظت الصفحة',
  },

  /** Shown while the read is in flight, and when it fails. */
  pending: 'جارٍ تحميل الصفحة…',
  retry: 'أعد المحاولة',
} as const;
